export enum EvaluationCycleState {
    DRAFT = 'DRAFT',
    SCHEDULED = 'SCHEDULED',
    ACTIVATED = 'ACTIVATED',
    CLOSED = 'CLOSED'
}